import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { motion, AnimatePresence } from "framer-motion";


const AccordionItem = ({ title, children, eventKey, isOpen, onClick }) => (
  <div className="accordion-item custom-accordion-item">
    <h2 className="accordion-header" id={`heading${eventKey}`}>
      <button
        className={`accordion-button ${isOpen ? "" : "collapsed"}`}
        type="button"
        onClick={onClick}
      >
        {title}
      </button>
    </h2>
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          key="content"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut", bounce: 0.2 }}
          className="accordion-body"
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const Bilgi = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div className="info">
    <Helmet>
      {/* SEO Başlık */}
      <title>Yararlı Bilgiler | Avukat Ankara | Ali Arda Gül Hukuk Bürosu</title>
  
      {/* SEO Açıklaması */}
      <meta
        name="description"
        content="Avukatlık hizmetleri hakkında yararlı bilgiler. Avukat temsil zorunluluğu, vekaletname çıkarma, avukatlık ücreti ve şehirler arası dava takibi hakkında bilgiler."
      />
  
      {/* Anahtar Kelimeler */}
      <meta
        name="keywords"
        content="Avukat, Ankara Avukat, Avukatlık Ücreti, Vekaletname, Hukuki Bilgiler, Şehirlerarası Dava Takibi"
      />
  
      {/* Yazar Adı */}
      <meta name="author" content="Ali Arda Gül Hukuk Bürosu" />
  
      {/* Open Graph Etiketleri */}
      <meta property="og:title" content="Yararlı Bilgiler | Avukat Ankara | Ali Arda Gül Hukuk Bürosu" />
      <meta
        property="og:description"
        content="Avukatlık hizmetleri hakkında yararlı bilgiler. Avukat temsil zorunluluğu, vekaletname çıkarma, avukatlık ücreti ve şehirler arası dava takibi hakkında bilgiler."
      />
      <meta property="og:image" content="https://aliardagul.av.tr/assets/logo.webp" />
      <meta property="og:url" content="https://aliardagul.av.tr/yararli-bilgiler" />
      <meta property="og:type" content="website" />
  
      {/* Twitter Card Etiketleri */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Yararlı Bilgiler | Avukat Ankara | Ali Arda Gül Hukuk Bürosu" />
      <meta
        name="twitter:description"
        content="Avukatlık hizmetleri hakkında yararlı bilgiler. Avukat temsil zorunluluğu, vekaletname çıkarma, avukatlık ücreti ve şehirler arası dava takibi hakkında bilgiler."
      />
      <meta name="twitter:image" content="https://aliardagul.av.tr/assets/logo.webp" />
  
      {/* Canonical URL */}
      <link rel="canonical" href="https://aliardagul.av.tr/yararli-bilgiler" />
  
      {/* Yapılandırılmış Veri (Schema.org) */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Article",
            "name": "Yararlı Bilgiler | Avukat Ankara | Ali Arda Gül Hukuk Bürosu",
            "url": "https://aliardagul.av.trttps://https://aliardagul.av.tr/yararli-bilgiler",
            "logo": "https://aliardagul.av.tr/assets/logo.webp",
            "description": "Avukatlık hizmetleri hakkında yararlı bilgiler. Avukat temsil zorunluluğu, vekaletname çıkarma, avukatlık ücreti ve şehirler arası dava takibi hakkında bilgiler.",
            "author": {
              "@type": "Organization",
              "name": "Ali Arda Gül Hukuk Bürosu",
              "url": "https://aliardagul.av.tr"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Ali Arda Gül Hukuk Bürosu",
              "url": "https://aliardagul.av.tr"
            }
          }
        `}
      </script>
    </Helmet>
    
    {/* Diğer İçerik */}
 
  

      <div>
        <h6 className="guide-text ms-3 mt-4">YARARLI BİLGİLER</h6>
        <div className="container py-5">
          <div id="accordion" className="accordion">
            <AccordionItem
              title="AVUKATLA TEMSİL ZORUNLU MU?"
              eventKey="One"
              isOpen={openIndex === "One"}
              onClick={() => toggleAccordion("One")}
            >
              <h5>Mevzuat:</h5>
              <p>
                19/3/1969 tarihli ve 1136 sayılı Avukatlık Kanunu'nun "Avukatlığın amacı" başlıklı 2. maddesi şu şekilde düzenlenmiştir:
                "Avukatlığın amacı, hukuki ilişkilerin düzenlenmesi, hukuki mesele ve anlaşmazlıkların adalet ve hakkaniyete uygun olarak çözümlenmesi ve hukuk kurallarının tam olarak uygulanmasını sağlamaktır. Avukat, bu amaçla hukuki bilgi ve tecrübelerini adalet hizmetine ve bireylerin yararına sunar…"
              </p>
              <p>
                Bu düzenlemeye göre, avukatlar hukuki ilişkileri düzenlemek, anlaşmazlıkları çözmek ve hukuk kurallarını uygulamak amacıyla hukuki bilgi ve tecrübelerini kullanır.
              </p>
              <p>
                Türk hukuk sisteminde, bazı istisnalar dışında avukatla temsil zorunlu değildir; ancak dava açma, savunma yapma ve dilekçelerin sunulması gibi süreçler karmaşık usul kurallarını içerir.
              </p>
              <p>
                Bu kuralların doğru uygulanmaması, davaların reddedilmesine ve hak kaybı yaşamanıza yol açabilir.
              </p>
              <p>
                Dolayısıyla, avukatlık hizmetlerinin sağladığı hukuki bilgi ve deneyimlerden yararlanmak, hak kaybını önlemek açısından faydalı olacaktır.
              </p>
            </AccordionItem>

            <AccordionItem
              title="AVUKAT VEKALETNAMESİ NASIL ÇIKARTILIR?"
              eventKey="Two"
              isOpen={openIndex === "Two"}
              onClick={() => toggleAccordion("Two")}
            >
              <p>
                Bir avukata vekalet vermeniz gereken durumlarda; Türkiye’de iseniz herhangi bir notere, yurt dışında iseniz Türkiye Cumhuriyeti Konsolosluklarına giderek vekil tayin etmek istediğiniz avukatın adı, soyadı, T.C. numarası, adresi bilgilerini vermeniz gerekmektedir.
              </p>
              <p>
                Noter, vekalet verecek olan şahsın ve vekalet verilecek olan avukatın bilgilerini aldıktan sonra, vekalet verecek olan şahsa hangi konuda (genel vekalet, özel vekalet vb.) vekalet vereceğini sorar. Hazırlanan vekaletnameyi imzalamanızın ardından bir nüshası size verilir ve işlemler tamamlanmış olur.
              </p>
              <p>
                Boşanma, nafaka, tanıma gibi özel yetki içeren vekaletnameler için son 6 ay içinde çekilmiş iki adet vesikalık fotoğraf da gereklidir.
              </p>
            </AccordionItem>

            <AccordionItem
              title="AVUKATLIK ÜCRETİ"
              eventKey="Three"
              isOpen={openIndex === "Three"}
              onClick={() => toggleAccordion("Three")}
            >
              <p>
                Avukatlık sözleşmesine dayanan vekalet ücreti, avukat ile müvekkil arasında yapılan ve tarafların hak ve yükümlülüklerini belirleyen, şekil şartına bağlı olmayan bir sözleşmeden kaynaklanır. Uygulamada "Akdi Vekalet Ücreti" olarak da bilinir.
              </p>
              <p>
                Akdi vekalet ücreti, dava veya hükmolunacak şeyin değeri üzerinden %25'i aşmamak üzere belirlenebilir.
              </p>
              <p>
                Mahkemece hükmolunan "Kanuni Vekalet Ücreti" ise, davanın feri niteliğindedir ve yalnızca vekil ile temsil edilen tarafa verilebilir.
              </p>
              <p>
                Özetle, avukat müvekkilinden sözleşmeye dayalı ücretini dava kaybedilse dahi alabilir; dava kazanılırsa ayrıca mahkeme tarafından hükmedilen vekalet ücretine de hak kazanır.
              </p>
            </AccordionItem>

            <AccordionItem
              title="AVUKAT BAŞKA BİR ŞEHİRDEKİ DAVAYI TAKİP EDEBİLİR Mİ?"
              eventKey="Four"
              isOpen={openIndex === "Four"}
              onClick={() => toggleAccordion("Four")}
            >
              <p>
                Avukatın kayıtlı olduğu baronun bulunduğu il dışında da dava alması ve iş takip etmesi mümkündür. Örneğin, Ankara Barosu'na kayıtlı bir avukat Eskişehir’de dava açabilir veya bir davayı takip edebilir.
              </p>
            </AccordionItem>

            <AccordionItem
              title="BİRDEN FAZLA AVUKATA VEKALET VEREBİLİR MİYİM?"
              eventKey="Five"
              isOpen={openIndex === "Five"}
              onClick={() => toggleAccordion("Five")}
            >
              <p>
                Taraflar, sayı sınırı olmaksızın birden fazla avukata vekalet verebilir. Her avukat bağımsız şekilde davayı yürütebilir.
              </p>
              <p>
                Ancak, bir avukattan sonra ikinci bir avukata vekalet verilmek istenirse, ikinci avukatın göreve başlamadan önce ilk avukata yazılı bilgi vermesi ve onay alması gerekir. Aksi halde, ilk avukat haklı sebeple işi bırakabilir ve vekalet ücretinin tamamına hak kazanabilir.
              </p>
            </AccordionItem>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bilgi;
